import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getAlmacenes() {
  var params =
    '?usuarioOK=' +
    getCookie('usuarioOk') +
    '&folioPedido=' +
    getCookie('folioPedido') +
    '&almacenSeleccionado=' +
    getCookie('warehouse') +
    '&dominio=' +
    window.location.hostname +
    '&origen=CARRITONUE';
  const url = `${webservice}/getAlmacenes${params}`;
  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
